export default "__VITE_ASSET__55691a7d__"